import React from "react";

const Theme = () => (
  <section id="theme">
    <div className="container">
      <div className="title-block">
        <h2>Theme</h2>
        <p>The theme of the National Data Science Challenge 2019 is Product Information Extraction in the Wild - a challenge to extract insightful knowledge from large volumes of textual and visual data using Machine Learning Analytics.</p>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="box">
            <small>Beginner Category</small>
            <h3>Product Category Classification</h3>
            <ul>
              <li>Students currently enrolled in junior colleges, polytechnics or universities in Singapore (including exchange students). </li>
              <li>Non-tech professionals working in Singapore who have little or no programming and/or Data Science experience</li>
            </ul>
          </div>
        </div>
        <div className="col-md-6">
          <div className="box">
            <small>Advanced Category</small>
            <h3>Product Information Extraction</h3>
            <ul>
              <li>Students currently enrolled in junior colleges, polytechnics or universities in Singapore (including exchange students).</li>
              <li>All non-tech and tech professionals working in Singapore.</li>
            </ul>
          </div>
        </div>
      </div>
      <p className="note">
        <small>*Teams comprising students and professionals will be reviewed on a case-by-case basis.</small>
      </p>
    </div>
  </section>
);

export default Theme;